import { CommonUtilities } from "../../../commonUtils";
//import Pagination from "components/Common/newPagination";
import Pagination from "../../Header/Pagination";
import React, { Suspense, useState, useEffect } from "react";
import trackServices from "./trackServices";
import ViewContractAsset from "../../Common/ViewContractAsset";
//import ViewContractTrackAsset from "./ViewContractTrackAsset";

export default function TrackListing(projectDetails : any){

    const [trackslist, initTrackslist] = useState<any[]>([]);
    const [totalRows ,setTotalRows] = useState(1);
    var dataLink = "pageSize=10&pageNumber=1"; 
  
    const Data:any =  {
        pageSize : 10,
        pageNumber : 1 ,
        ProjectId: projectDetails.projectDetails.ProjectId,
        assetType : 'track'
    }
    const handleNameOnChange = (n: any) => {  
        Data.pageNumber = n.pageNumber;
        Data.pageSize =n.pageSize;
        getTrackes()
    }

    useEffect(() => {
        getTrackes()       
    }, []);
    
    const getTrackes = () => {
        dataLink = 'projectId='+Data.ProjectId + '&assetType='+Data.assetType + '&pageSize=' + Data.pageSize +'&pageNumber=' + Data.pageNumber;
        Data.ProjectId =projectDetails.projectDetails.ProjectId ;
        trackServices.TrackListing(dataLink)
        .then((res) => {
            if(res.length === 0){
                projectDetails.onChange(0)
                setTotalRows(0);
            }else{
                initTrackslist(res)
                setTotalRows(res[0].totalRows)
                projectDetails.onChange(res[0].totalRows)
            }

        })
    }

    return (        
       
            <div className="box-content p0">
            <Suspense fallback={<div>Loading</div>}>

                <div className="allowHscroll">
                    {
                        (() => {
                            if(totalRows && totalRows>0){
                                return ( 
                                <table>
                                    <thead>
                                        <tr className="forceSingleLine">
                                            <th>ISRC</th>
                                            <th>Track Title</th>
                                            <th>Track Artist Code</th>
                                            <th>Track Artist Display</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            trackslist.map(post => (
                                                <tr className="forceSingleLine">
                                                    <td>{post.code}                                        
                                                     {<ViewContractAsset data={post} type="track" projectId={Data.ProjectId}/> /* */}                                      
                                                    </td>
                                                    <td>{post.name}</td>
                                                    <td>{post.trackArtistCode}</td>
                                                    <td>{post.trackArtistDisplay}</td>
                                                </tr>
                                            ))
                                        }
                
                                    </tbody>
                                </table>)
                            } else {
                                return (<div className="ptl">
                                    <span className="alert alert-success ws-12 text-center">No data Available</span>
                                </div>)
                            }
                        })()
                    }
                </div>


                <div className="ws-12"> 
                    {     
                
                        (() => {
                            if(totalRows && totalRows>10){
                                return  <Pagination onPageChange={handleNameOnChange} totalRow={totalRows} />
                            }
                            
                        })()
                        
                    } 
                </div>
            </Suspense>
            </div>
    )
}